const FOOTER_COLS = [
  {
    title: '频道',
    links: ['今日瓜榜', '猛料速递', '劲爆时间轴', '压轴盘点', '圈内热评'],
  },
  {
    title: '内容类型',
    links: ['黑料王猛料', '黑料王大瓜', '高能复盘', '辟谣专区', '串瓜名场面'],
  },
  {
    title: '关于',
    links: ['关于黑料王', '内容说明', '爆料投稿', '合作联系', '隐私声明'],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-heading text-2xl font-black text-foreground-950">黑料王</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个把高能猛料、大瓜与劲爆复盘做得干净利落的资讯聚合站。
              封面直击、时间线还原、话题墙串瓜，压轴高能内容持续更新。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['猛料', '大瓜', '高能', '劲爆'].map((k) => (
                <span
                  key={k}
                  className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600"
                >
                  #{k}
                </span>
              ))}
            </div>
          </div>

          {FOOTER_COLS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="inline-block cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 text-xs text-secondary-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 黑料王。内容为演示展示，仅供娱乐参考。</p>
          <div className="flex flex-wrap items-center gap-4">
            <a href="#top" className="hover:text-foreground-800">服务条款</a>
            <a href="#top" className="hover:text-foreground-800">隐私政策</a>
            <a href="#top" className="hover:text-foreground-800">免责声明</a>
            <span className="inline-flex items-center gap-1.5">
              <i className="ri-flag-2-line" /> 内容聚合演示站
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}